module.exports = __webpack_public_path__ + "img/img16.10f76bfd.png";